/**
 * Shipping options – GBP
 * Local = UK. International = rest of world.
 */
export const SHIPPING_LOCAL_GBP = 4.99;
export const SHIPPING_INTERNATIONAL_GBP = 12.99;

export type ShippingOption = 'local' | 'international';

export const UK_COUNTRY_CODES = ['GB', 'UK'];
export const UK_COUNTRY_NAMES = ['United Kingdom', 'UK', 'Great Britain'];

export function getShippingCost(option: ShippingOption): number {
  return option === 'local' ? SHIPPING_LOCAL_GBP : SHIPPING_INTERNATIONAL_GBP;
}

export function isLocalByCountry(countryCode: string): boolean {
  const code = (countryCode || '').toUpperCase().trim();
  return UK_COUNTRY_CODES.includes(code) || code === 'UNITED KINGDOM';
}

/** Common countries for dropdown – UK first, then others. */
export const COUNTRY_OPTIONS: { code: string; name: string }[] = [
  { code: 'GB', name: 'United Kingdom' },
  { code: 'IE', name: 'Ireland' },
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'ES', name: 'Spain' },
  { code: 'IT', name: 'Italy' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'BE', name: 'Belgium' },
  { code: 'OTHER', name: 'Other' },
];
